import { render } from "./AppNavIcon.vue?vue&type=template&id=fb0371e2"
import script from "./AppNavIcon.vue?vue&type=script&lang=js"
export * from "./AppNavIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__